import { BUSERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import busersTypes from '../../constants/busersTypes'
import { axios } from '../../services'

//
const get_buser_request = () => {
  return {
    type: busersTypes.get.request
  }
}

const get_buser_success = (response) => {
  return {
    type: busersTypes.get.success,
    payload: response.data.buser
  }
}

const get_buser_failure = (messages) => {
  return {
    type: busersTypes.get.failure,
    payload: messages
  }
}

const get_buser = (buser_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_buser_request())

    // Request
    axios.get(
      formatRoute(BUSERS_ROUTES.get, {id: buser_id})
    ).then( response => {
      // success
      dispatch( get_buser_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching user."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_buser_failure(errors))
    })
  }

}

export {
  get_buser
}



// WEBPACK FOOTER //
// ./src/js/actions/busers/get.js